{
  "Accessibility menu": "ಪ್ರವೇಶಮಾಡುವಿಕೆ ಮೆನು",
  "Close": "ಮುಚ್ಚಿ",
  "Content adjustments": "ವಿಷಯದ ಹೊಂದಾಣಿಕೆಗಳು",
  "Navigation adjustments": "ನ್ಯಾವಿಗೇಶನ್ ಹೊಂದಾಣಿಕೆಗಳು",
  "Align Left": "ಎಡಕ್ಕೆ ಜೋಡಿಸಿ",
  "Adjust Font Size": "ಅಕ್ಷರದ ಗಾತ್ರವನ್ನು ಹೊಂದಿಸಿ",
  "Highlight Title": "ಶೀರ್ಷಿಕೆಯನ್ನು ಹೈಲೈಟ್ ಮಾಡಿ",
  "Highlight Links": "ಲಿಂಕ್‌ಗಳನ್ನು ಹೈಲೈಟ್ ಮಾಡಿ",
  "Readable Font": "ಓದಲು ಸುಲಭವಾದ ಅಕ್ಷರಶೈಲಿ",
  "Colour adjustments": "ಬಣ್ಣ ಹೊಂದಾಣಿಕೆಗಳು",
  "Dark Contrast": "ಕತ್ತಲೆ ವ್ಯತ್ಯಾಸ",
  "Light Contrast": "ಹಗುರ ವ್ಯತ್ಯಾಸ",
  "High Contrast": "ಹೆಚ್ಚು ವ್ಯತ್ಯಾಸ",
  "High Saturation": "ಹೆಚ್ಚು ಸಾತುರ್ನತೆ",
  "Low Saturation": "ಕಡಿಮೆ ಸಾತುರ್ನತೆ",
  "Monochrome": "ಏಕವರ್ಣ",
  "Tools": "ಉಪಕರಣಗಳು",
  "Reading Guide": "ಓದುವ ಮಾರ್ಗದರ್ಶಿ",
  "Big Cursor": "ದೊಡ್ಡ ಕರ್ಸರ್",
  "Increase Font Size": "ಅಕ್ಷರದ ಗಾತ್ರವನ್ನು ಹೆಚ್ಚಿಸಿ",
  "Decrease Font Size": "ಅಕ್ಷರದ ಗಾತ್ರವನ್ನು ಕಡಿಮೆ ಮಾಡಿ",
  "Letter Spacing": "ಅಕ್ಷರಗಳ ನಡುವಿನ ಅಂತರ",
  "Line Height": "ಸಾಲಿನ ಎತ್ತರ",
  "Font Weight": "ಅಕ್ಷರದ ತೂಕ",
  "Dyslexia Font": "ಡಿಸ್ಲೆಕ್ಸಿಯಾ ಅಕ್ಷರಶೈಲಿ",
  "Language": "ಭಾಷೆ",
  "Accessibility widget": "ಪ್ರವೇಶಮಾಡುವಿಕೆ ಮೆನು ಅನ್ನು ತೆರೆಯಿರಿ",
  "Accessibility Profiles": "ಪ್ರವೇಶಮಾಡುವಿಕೆ ಪ್ರೊಫೈಲ್‌ಗಳು",
  "Cognitive Disability": "ಜ್ಞಾನಾತ್ಮಕ ಅಂಗವೈಕಲ್ಯ",
  "Seizure Safe": "ಅಪಸ್ಮಾರಕ್ಕೆ ಸುರಕ್ಷಿತ",
  "Accessibility statement": "ಪ್ರವೇಶಮಾಡುವಿಕೆ ಹೇಳಿಕೆ",
  "ADHD": "ADHD",
  "Low Vision": "Low Vision",
  "Pause Animations": "ಅನಿಮೇಶನ್‌ಗಳನ್ನು ನಿಲ್ಲಿಸಿ",
  "Reset all settings": "ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಮರುಹೊಂದಿಸಿ",
  "Shortcut:": "Shortcut:"
}
